import { NgClass } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, input, signal, ViewEncapsulation } from '@angular/core';
import { RouterLinkDirective } from '@hyundai/ng-common-lib';
import { M000C010ImageComponent, M010C020IconLinkComponent } from '@hyundai/ui';
import {
    NgxPxCarouselAwesomePlusComponent,
    NgxPxCarouselAwesomePlusItemDirective,
} from '@pixelgenau/ngx-carousel-awesome-plus';

@Component({
    selector: 'lib-distribution-receipt-step',
    standalone: true,
    templateUrl: './distribution-receipt.component.html',
    styleUrl: './distribution-receipt.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgxPxCarouselAwesomePlusComponent,
        NgxPxCarouselAwesomePlusItemDirective,
        M000C010ImageComponent,
        M010C020IconLinkComponent,
        RouterLinkDirective,
        NgClass,
    ],
})
export default class DistributionReceiptComponent {
    vehicleName = input.required<string>();
    vehicleSubName = input<string>();
    price = input.required<string>();
    envkv = input.required<string>();
    financingPrice = input<string>();
    images = input<string[]>();
    showAccesories = input(false, { transform: booleanAttribute });
    accesories = input<string[]>();
    accesorieLink = input<string>();

    openAccesories = signal(false);
}
